// Elegant initials-based avatar for team members without an authentic photograph.
// Uses the person's first + last name initials on a subtle branded gradient.
export default function InitialsAvatar({ name = "", aspect = "aspect-square", className = "" }) {
  const parts = name.replace(/^Dr\.?\s+/i, "").trim().split(/\s+/).filter(Boolean);
  const initials = parts.length >= 2
    ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    : (parts[0]?.slice(0, 2) || "DS").toUpperCase();

  // Deterministic gentle hue from the name so cards look varied but consistent.
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) & 0xffffffff;
  const palettes = [
    { from: "#0F2C59", to: "#1E3F7A" },
    { from: "#13355F", to: "#264D8A" },
    { from: "#0A2450", to: "#173C74" },
    { from: "#122E5A", to: "#22467E" },
  ];
  const p = palettes[Math.abs(hash) % palettes.length];

  return (
    <div
      className={`rounded-2xl w-full ${aspect} ${className} relative overflow-hidden flex items-center justify-center text-white`}
      style={{ background: `linear-gradient(135deg, ${p.from} 0%, ${p.to} 100%)` }}
      data-testid={`initials-avatar-${initials}`}
      aria-hidden="true"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{ backgroundImage: "radial-gradient(120% 90% at 20% 15%, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0) 55%)" }}
      />
      <span className="font-display font-extrabold text-4xl sm:text-5xl tracking-wide select-none">{initials}</span>
    </div>
  );
}
